/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonRelayItem,
    JsonRelayItemFromJSON,
    JsonRelayItemFromJSONTyped,
    JsonRelayItemToJSON,
} from './JsonRelayItem';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonRelayItem
 */
export interface ApiResultOfListOfJsonRelayItem {
    /**
     * 
     * @type {Array<JsonRelayItem>}
     * @memberof ApiResultOfListOfJsonRelayItem
     */
    data?: Array<JsonRelayItem>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonRelayItem
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonRelayItem
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonRelayItem
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonRelayItem
     */
    result?: ApiResultOfListOfJsonRelayItemResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonRelayItemResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonRelayItemFromJSON(json: any): ApiResultOfListOfJsonRelayItem {
    return ApiResultOfListOfJsonRelayItemFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonRelayItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonRelayItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonRelayItemFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonRelayItemToJSON(value?: ApiResultOfListOfJsonRelayItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonRelayItemToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

